import type { PathArray, PathSegment } from "../types";

/**
 * The `PathParser` is used by the `parsePathString` static method
 * to generate a `pathArray`.
 *
 * @param pathString - The SVG path string to parse
 */
export class PathParser {
  declare segments: PathArray | PathSegment[];
  declare pathValue: string;
  declare max: number;
  declare index: number;
  declare param: number;
  declare segmentStart: number;
  declare data: (string | number)[];
  declare err: string;

  constructor(pathString: string) {
    this.segments = [];
    this.pathValue = pathString;
    this.max = pathString.length;
    this.index = 0;
    this.param = 0.0;
    this.segmentStart = 0;
    this.data = [];
    this.err = "";
  }
}
